import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronRightOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m11.5 8-5 5-.99-.99L9.52 8 5.51 3.99 6.5 3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronRightOutlinedSize16Glyph.displayName = 'ChevronRightOutlinedSize16Glyph';
